import { useState, useEffect, useContext } from 'react'
import { FiEdit, FiFilter, FiRotateCcw } from 'react-icons/fi'
import { FaSearch } from 'react-icons/fa'
import { Link, useAsyncError } from 'react-router-dom'
import {
  addDoc,
  collection,
  getDoc,
  getDocs,
  query,
  orderBy,
  where,
  onSnapshot,
  updateDoc,
  doc,
  deleteDoc
} from 'firebase/firestore'
import { FiX } from "react-icons/fi";

import { Header } from '../../components/Header'
import { Title } from '../../components/Title'
import { AuthContext } from '../../contexts/auth'
import { db } from '../../services/firebaseConnection'

import { Content } from './styles'

import tesouraImg from '../../assets/tesoura.png'
import { toast } from 'react-toastify';
import { setTextRange } from 'typescript'

const listRefDiscipline = collection(db, "discipline")
const listRefSubject = collection(db, "subject")
const listRefOrganizer = collection(db, "organizer")
const listRefInstitution = collection(db, "institution")
const listRefProfession = collection(db, "profession")
const listRefProfessionalQualification = collection(db, "professionalQualification")
const listRefWorkspace = collection(db, "workspace")

export function Questions() {
  const { user, questions, setQuestions } = useContext(AuthContext)
  //console.log("USER: ", user)

  const [discipline, setDiscipline] = useState([])
  const [disciplineSaved, setDisciplineSaved] = useState('')
  const [subject, setSubject] = useState([])
  const [subjectSaved, setSubjectSaved] = useState('')
  const [year, setYear] = useState('')
  const [difficulty, setDifficulty] = useState('')
  const [organizer, setOrganizer] = useState([])
  const [organizerSaved, setOrganizerSaved] = useState('')
  const [institution, setInstitution] = useState([])
  const [institutionSaved, setInstitutionSaved] = useState('')
  const [profession, setProfession] = useState([])
  const [professionSaved, setProfessionSaved] = useState('')
  const [professionalQualification, setProfessionalQualification] = useState([])
  const [professionalQualificationSaved, setProfessionalQualificationSaved] = useState('')
  const [workspace, setWorkspace] = useState([])
  const [workspaceSaved, setWorkspaceSaved] = useState('')
  const [modality, setModality] = useState('')

  const [loadingDiscipline, setLoadingDiscipline] = useState(true)
  const [loadingSubject, setLoadingSubject] = useState(true)
  const [loadingOrganizer, setLoadingOrganizer] = useState(true)
  const [loadingInstitution, setLoadingInstitution] = useState(true)
  const [loadingProfession, setLoadingProfession] = useState(true)
  const [loadingProfessionalQualification, setLoadingProfessionalQualification] = useState(true)
  const [loadingWorkspace, setLoadingWorkspace] = useState(true)

  const [categoryQuestions, setCategoryQuestions] = useState({})
  //console.log("categoryQuestions: ", categoryQuestions)

  const [cutOptions, setCutOptions] = useState({});
  //console.log("CUT-OPTIONS: ", cutOptions)
  const [selectedOption, setSelectedOption] = useState(null);
  console.log("SELECTED-OPTION: ", selectedOption)
  const [verifyOptionId, setVerifyOptionId] = useState(null)
  const [optionA, setOptionA] = useState(null)
  //console.log("optionA: ", optionA)
  const [optionB, setOptionB] = useState(null)
  //console.log("optionB: ", optionB)
  const [optionC, setOptionC] = useState(null)
  //console.log("optionC: ", optionC)
  const [optionD, setOptionD] = useState(null)
  //console.log("optionD: ", optionD)
  const [optionE, setOptionE] = useState(null)
  //console.log("optionE: ", optionE)

  const [viewResponse, setViewResponse] = useState(false)
  const [trueFalse, setTrueFalse] = useState('')
  const [disableComment, setDisableComment] = useState(false)
  const [disableLearnVideo, setDisableLearnVideo] = useState(false)

  const [viewCommentQuestion, setViewCommentQuestion] = useState(false)
  const [viewVideoLearnQuestion, setViewVideoLearnQuestion] = useState(false)
  const [visibleButtonResponse, setVisibleButtonResponse] = useState(false)

  const [getQuestions, setGetQuestions] = useState([])
  //console.log("GET-QUESTIONS: ", getQuestions)

  useEffect(() => {

    async function loadingSubject() {
      const querySnapshot = await getDocs(listRefSubject)
        .then((snapshot) => {
          const lista = [];

          snapshot.forEach((doc) => {
            const subjectData = doc.data();

            // Verifica se o documento está associado à disciplina desejada
            if (subjectData.discipline === disciplineSaved) {
              lista.push({
                id: doc.id,
                subject: subjectData.subject,
                discipline: subjectData.discipline
              });
            }
          });

          if (lista.length === 0) {
            setDiscipline([{ id: 1, subject: "Nenhuma disciplina encontrada para esta disciplina" }]);
            setLoadingDiscipline(false);
            return;
          }

          setSubject(lista);
          setLoadingSubject(false);
        })
        .catch((err) => {
          //console.log(err);
          setSubject([{ id: 1, subject: "Algo de errado" }]);
          setLoadingSubject(false);
        });
    }

    loadingSubject()

  }, [disciplineSaved])

  useEffect(() => {
    async function loadingDiscipline() {
      const querySnapshot = await getDocs(listRefDiscipline)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              discipline: doc.data().discipline
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setDiscipline([{ id: 1, discipline: "Algo de errado" }])
            setLoadingDiscipline(false)
            return
          }

          setDiscipline(lista)
          setLoadingDiscipline(false)
        })
        .catch((err) => {
          //console.log(err)
          setDiscipline([{ id: 1, discipline: "Algo de errado" }])
          setLoadingDiscipline(false)
        })
    }

    loadingDiscipline()

    async function loadingOrganizer() {
      const querySnapshot = await getDocs(listRefOrganizer)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              organizer: doc.data().organizer
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setOrganizer([{ id: 1, discipline: "Algo de errado" }])
            setLoadingOrganizer(false)
            return
          }

          setOrganizer(lista)
          setLoadingOrganizer(false)
        })
        .catch((err) => {
          //console.log(err)
          setOrganizer([{ id: 1, discipline: "Algo de errado" }])
          setLoadingOrganizer(false)
        })
    }

    loadingOrganizer()

    async function loadingInstitution() {
      const querySnapshot = await getDocs(listRefInstitution)
        .then((snapshot) => {
          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              institution: doc.data().institution
            })
          })

          if (snapshot.docs.size === 0) {
            setInstitution([{ id: 1, discipline: "Algo de errado" }])
            setLoadingInstitution(false)
            return
          }

          setInstitution(lista)
          setLoadingInstitution(false)
        })
        .catch((err) => {
          //console.log(err)
          setInstitution([{ id: 1, discipline: "Algo de errado" }])
          setLoadingInstitution(false)
        })
    }

    loadingInstitution()

    async function loadingProfession() {
      const querySnapshot = await getDocs(listRefProfession)
        .then((snapshot) => {

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              profession: doc.data().profession
            })
          })

          if (snapshot.docs.size === 0) {
            setProfession([{ id: 1, discipline: "Algo de errado" }])
            setLoadingProfession(false)
            return
          }

          setProfession(lista)
          setLoadingProfession(false)
        })
        .catch((err) => {
          //console.log(err)
          setProfession([{ id: 1, discipline: "Algo de errado" }])
          setLoadingProfession(false)
        })
    }

    loadingProfession()

    async function loadingProfessionalQualification() {
      const querySnapshot = await getDocs(listRefProfessionalQualification)
        .then((snapshot) => {

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              professionalQualification: doc.data().professionalQualification
            })
          })

          if (snapshot.docs.size === 0) {
            setProfessionalQualification([{ id: 1, discipline: "Algo de errado" }])
            setLoadingProfessionalQualification(false)
            return
          }

          setProfessionalQualification(lista)
          setLoadingProfessionalQualification(false)
        })
        .catch((err) => {
          //console.log(err)
          setProfessionalQualification([{ id: 1, discipline: "Algo de errado" }])
          setLoadingProfessionalQualification(false)
        })
    }

    loadingProfessionalQualification()

    async function loadingWorkspace() {
      const querySnapshot = await getDocs(listRefWorkspace)
        .then((snapshot) => {

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              workspace: doc.data().workspace
            })
          })

          if (snapshot.docs.size === 0) {
            setWorkspace([{ id: 1, discipline: "Algo de errado" }])
            setLoadingWorkspace(false)
            return
          }

          setWorkspace(lista)
          setLoadingWorkspace(false)
        })
        .catch((err) => {
          //console.log(err)
          setWorkspace([{ id: 1, discipline: "Algo de errado" }])
          setLoadingWorkspace(false)
        })
    }

    loadingWorkspace()

  }, [])

  useEffect(() => {
    async function handleCategoryQuestion() {
      const categorys = {
        discipline: disciplineSaved,
        subject: subjectSaved,
        year: year,
        difficulty: difficulty,
        organizer: organizerSaved,
        institution: institutionSaved,
        profession: professionSaved,
        professionalQualification: professionalQualificationSaved,
        workspace: workspaceSaved
      }

      setCategoryQuestions(categorys)
    }

    handleCategoryQuestion()
  }, [disciplineSaved, subjectSaved, year, difficulty, organizerSaved,
    institutionSaved, professionSaved, professionalQualificationSaved,
    workspaceSaved])

  function handleChangeDiscipline(e) {
    setDisciplineSaved(discipline[e.target.value].discipline)
  }

  function handleChangeSubject(e) {
    setSubjectSaved(subject[e.target.value].subject)
  }

  function handleChangeYear(e) {
    //setDiscipline(e.target.value)
    setYear(e.target.value)
  }

  function handleChangeOrganizer(e) {
    //e.prevetDefault()
    setOrganizerSaved(organizer[e.target.value].organizer)
  }

  function handleChangeInstitution(e) {
    setInstitutionSaved(institution[e.target.value].institution)
  }

  function handleChangeProfession(e) {
    setProfessionSaved(profession[e.target.value].profession)
  }

  function handleChangeDifficulty(e) {
    setDifficulty(e.target.value)
  }

  function handleChangeProfessionalQualification(e) {
    setProfessionalQualificationSaved(professionalQualification[e.target.value].professionalQualification)
  }

  function handleChangeWorkspace(e) {
    setWorkspaceSaved(workspace[e.target.value].workspace)
  }

  async function handleOtionsQuestion() {
    const questionsCollection = collection(db, "questions")

    let combinedQuery = query(questionsCollection, orderBy("created", "desc"))

    if (disciplineSaved) {

      combinedQuery = query(combinedQuery, where("discipline", "==", disciplineSaved))
    }

    if (subjectSaved) {
      combinedQuery = query(combinedQuery, where("subject", "==", subjectSaved))
    }

    if (organizerSaved) {
      combinedQuery = query(combinedQuery, where("organizer", "==", organizerSaved))
    }

    if (institutionSaved) {
      combinedQuery = query(combinedQuery, where("institution", "==", institutionSaved))
    }

    if (year) {
      combinedQuery = query(combinedQuery, where("year", "==", year))
    }

    if (professionSaved) {
      combinedQuery = query(combinedQuery, where("profession", "==", professionSaved))
    }

    if (difficulty) {
      combinedQuery = query(combinedQuery, where("difficulty", "==", difficulty))
    }

    if (professionalQualificationSaved) {
      combinedQuery = query(combinedQuery, where("professionalQualification", "==", professionalQualificationSaved))
    }

    if (workspaceSaved) {
      combinedQuery = query(combinedQuery, where("workspace", "==", workspaceSaved))
    }


    onSnapshot(combinedQuery, (snapshot) => {
      //console.log("QUESTOES: ", snapshot)

      let lista = []

      snapshot.forEach((doc) => {

        lista.push({
          id: doc.id,
          q: doc.data().q,
          enunciation: doc.data().enunciation,
          comments: doc.data().comments,
          isNull: doc.data().isNull,
          options: doc.data().options,
          created: doc.data().created,
          discipline: doc.data().discipline,
          subject: doc.data().subject,
          year: doc.data().year,
          organizer: doc.data().organizer,
          institution: doc.data().institution,
          profession: doc.data().profession,
          difficulty: doc.data().difficulty,
          professionalQualification: doc.data().professionalQualification,
          workspace: doc.data().workspace,
          modality: doc.data().modality
        })

        setGetQuestions(lista)
      })

      //console.log("LISTA: ", lista)
    })
  }

  async function handleSearchQuestion() {
    const questionsCollection = collection(db, "questions")

    onSnapshot(questionsCollection, (snapshot) => {

      let lista = []

      snapshot.forEach((doc) => {

        lista.push({
          id: doc.id,
          q: doc.data().q,
          enunciation: doc.data().enunciation,
          comments: doc.data().comments,
          options: doc.data().options,
          referenceLink: doc.data().referenceLink,
          isNull: doc.data().isNull,
          created: doc.data().created,
          discipline: doc.data().discipline,
          subject: doc.data().subject,
          year: doc.data().year,
          organizer: doc.data().organizer,
          institution: doc.data().institution,
          profession: doc.data().profession,
          difficulty: doc.data().difficulty,
          professionalQualification: doc.data().professionalQualification,
          workspace: doc.data().workspace,
          modality: doc.data().modality
        })

        //setQuestions(lista)
        setGetQuestions(lista)
      })
    })
  }

  const handleCutOption = (optionKey) => {
    //console.log("OPTION-KEY: ", optionKey)
    setCutOptions((prev) => ({
      ...prev,
      [optionKey]: true,
    }));

  };

  const handleUncutOpption = (optionKey, question) => {
    console.log("OPTION-KEY-UNCUT: ", optionKey)
    //console.log("question: ", question)
    //console.log("option: ", question)

    const isCorrectOptions = question.options
    //console.log("isCorrectOptions: ", isCorrectOptions.A.isCorrect)
    setOptionA(isCorrectOptions.A.isCorrect)
    setOptionB(isCorrectOptions.B.isCorrect)
    setOptionC(isCorrectOptions.C.isCorrect)
    setOptionD(isCorrectOptions.D.isCorrect)
    setOptionE(isCorrectOptions.E.isCorrect)
    //console.log("isCorrectOptions.E.isCorrec: ", isCorrectOptions.E.isCorrec)

    setCutOptions((prev) => ({
      ...prev,
      [optionKey]: ![optionKey],
    }));

    setSelectedOption(optionKey)
    setVisibleButtonResponse(true)
    //setVerifyOptionId(question.id)
  };

  async function handleResponse(questionId) {
    console.log("QUESTION-ID: ", questionId)
    setSelectedOption(questionId);
    //console.log("SelectedOption: ", selectedOption)
    //console.log("CutOptions: ", cutOptions)

    //question.options[optionKey]
    const option2 = {
      alternative: selectedOption,
      isCorrect: 'true'
    }

    //console.log("option2.isCorrect: ", option2.isCorrect)
    //console.log("optionA: ", optionA)

    // console.log("option2.isCorrect: ", option2.isCorrect)
    // console.log("optionB: ", optionB)

    if (option2.isCorrect === optionA || optionB || optionC || optionD || optionE) {
      setViewResponse(true)

      if (optionA === 'true') {
        setTrueFalse('Letra A')
      } else if (optionB === 'true') {
        setTrueFalse("Letra B")
      } else if (optionC === 'true') {
        setTrueFalse("Letra C")
      } else if (optionD === 'true') {
        setTrueFalse("Letra D")
      } else {
        setTrueFalse("Letra E")
      }
    }

    setDisableComment(true)
    setDisableLearnVideo(true)

    setViewCommentQuestion(false)
    setViewVideoLearnQuestion(false)
    setVisibleButtonResponse(false)

  }

  async function handleDeletQuestions(questionId) {
    await deleteDoc(doc(db, "questions", questionId))
      .then(() => {

      })
      .catch((err) => {
        console.log({ err: err })
      })
  }

  const isOptionSelected = selectedOption !== null;
  //console.log("IS-OPTION-SELECTED: ", isOptionSelected)
  const isOptionId = verifyOptionId !== null
  //console.log("QUESTION-ID: ", isOptionSelected)

  function viewComment() {
    setViewCommentQuestion(true)
  }

  function viewVideoLearn() {
    setViewVideoLearnQuestion(true)
  }

  return (
    <>
      <Header />
      <Content>
        {user.status.adm === true ? (
          <Title name="Questões">
            <FiEdit size={25} />
          </Title>
        ) : (
          <></>
        )}


        <div className='header-options'>
          <div className='minhas-questoes'>
            <p>Minhas Questões </p>
            <div className='box-buttons'>
              <button className='btn-tipo'>Todas</button>
              <button disabled={true} className='btn-tipo'>Resolvidas</button>
              <button disabled={true} className='btn-tipo'>Não Resolvidas</button>
              <button disabled={true} className='btn-tipo' >Acertei</button>
              <button disabled={true} className='btn-tipo'>Errei</button>
            </div>
          </div>
          <div className='box-categorys'>
            <div className='box-search'>
              <input className='assunto-input' type='text' placeholder='digite aqui' />
              <button onClick={handleSearchQuestion} className='btn-search-question'><FaSearch /></button>
            </div>
            {
              loadingDiscipline ? (
                <input type='text' disabled={true} value="Carregando..." />
              ) : (
                <select onChange={handleChangeDiscipline} >
                  {discipline.map((item, index) => {
                    return (
                      <>
                        <option key={index} value={index} >
                          {item.discipline}
                        </option>
                      </>
                    )
                  })}
                </select>
              )
            }
            {
              loadingSubject ? (
                <input className='assunto' type='text' disabled placeholder="Selecione o Assunto" />
              ) : (
                <select onChange={handleChangeSubject} >
                  {subject.map((item, index) => {
                    return (
                      <option key={index} value={index} >
                        {item.subject}
                      </option>
                    )
                  })}
                </select>
              )
            }
            {
              loadingOrganizer ? (
                <input type='text' disabled={true} value="Carregando..." />
              ) : (
                <select onChange={handleChangeOrganizer} >
                  {organizer.map((item, index) => {
                    return (
                      <option key={index} value={index} >
                        {item.organizer}
                      </option>
                    )
                  })}
                </select>
              )
            }

            {
              loadingInstitution ? (
                <input type='text' disabled={true} value="Carregando..." />
              ) : (
                <select onChange={handleChangeInstitution} >
                  {institution.map((item, index) => {
                    return (
                      <option key={index} value={index} >
                        {item.institution}
                      </option>
                    )
                  })}
                </select>
              )
            }
            <select onChange={handleChangeYear}>
              <option>Selecione o Ano</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
              <option value="2022">2022</option>
              <option value="2021">2021</option>
              <option value="2020">2020</option>
              <option value="2019">2019</option>
            </select>
            {
              loadingProfession ? (
                <input type='text' disabled={true} value="Carregando..." />
              ) : (
                <select onChange={handleChangeProfession} >
                  {profession.map((item, index) => {
                    return (
                      <option key={index} value={index} >
                        {item.profession}
                      </option>
                    )
                  })}
                </select>
              )
            }
            <select onChange={handleChangeDifficulty}>
              <option>Selecione o Nível</option>
              <option value="Fundamental" >Fundamental</option>
              <option value="Medio" >Médio</option>
              <option value="Superior" >Superior</option>
            </select>
            {
              loadingProfessionalQualification ? (
                <input type='text' disabled={true} value="Carregando..." />
              ) : (
                <select onChange={handleChangeProfessionalQualification} >
                  {professionalQualification.map((item, index) => {
                    return (
                      <option key={index} value={index} >
                        {item.professionalQualification}
                      </option>
                    )
                  })}
                </select>
              )
            }
            {
              loadingWorkspace ? (
                <input type='text' disabled={true} value="Carregando..." />
              ) : (
                <select onChange={handleChangeWorkspace} >
                  {workspace.map((item, index) => {
                    return (
                      <option key={index} value={index} >
                        {item.workspace}
                      </option>
                    )
                  })}
                </select>
              )
            }
          </div>

          {/* <div className='minhas-questoes'>
            <p>Excluir Questões: </p>
            <div className='box-check'>
              <div className='box'>
                <input type='checkbox' />
                <label>Dos meus cadernos</label>
              </div>
              <div className='box'>
                <input type='checkbox' />
                <label>Dos meus simulados</label>
              </div>
              <div className='box'>
                <input type='checkbox' />
                <label>Anuladas</label>
              </div>
              <div className='box'>
                <input type='checkbox' />
                <label>Desatualizadas</label>
              </div>
            </div>
          </div> */}
          {/* <div className='minhas-questoes'>
            <p>Questões com: </p>
            <div className='box-check'>
              <div className='box'>
                <input type='checkbox' />
                <label>Gabarito Comentado</label>
              </div>
              <div className='box'>
                <input type='checkbox' />
                <label>Comentários</label>
              </div>
              <div className='box'>
                <input type='checkbox' />
                <label>Meus Comentários</label>
              </div>
              <div className='box'>
                <input type='checkbox' />
                <label>Aulas</label>
              </div>
              <div className='box'>
                <input type='checkbox' />
                <label>Minhas Anotações</label>
              </div>
            </div>
          </div> */}

          <div className='minhas-questoess'>
            <div className='box-filtro'>
              <p style={{ marginRight: 5 }}>Filtrar por:</p>

              <div style={{ display: 'flex', gap: 10 }}>
                {categoryQuestions.discipline ? (
                  <p style={{ display: 'flex', gap: 10 }}>
                    <p>Discipline: {categoryQuestions?.discipline}</p>
                  </p>
                ) : (
                  <></>
                )}

                {categoryQuestions.subject ? (
                  <p style={{ display: 'flex', gap: 10 }}>
                    <p>Assunto: {categoryQuestions?.discipline}</p>
                  </p>
                ) : (
                  <></>
                )}

                {categoryQuestions.organizer ? (
                  <p style={{ display: 'flex', gap: 10 }}>
                    <p>Banca: {categoryQuestions?.organizer}</p>
                  </p>
                ) : (
                  <></>
                )}

                {categoryQuestions.institution ? (
                  <p style={{ display: 'flex', gap: 10 }}>
                    <p>Orgão: {categoryQuestions?.institution}</p>
                  </p>
                ) : (
                  <></>
                )}

                {categoryQuestions.year ? (
                  <p style={{ display: 'flex', gap: 10 }}>
                    <p>Ano: {categoryQuestions?.year}</p>
                  </p>
                ) : (
                  <></>
                )}
              </div>

            </div>
            <div className='box-buttons'>
              {/* <div className='sub-box-btn'>
                <button className='btn-filter'><FiFilter /></button>
                <lable>Salvar filtro</lable>
              </div> */}
              {/* <div className='sub-box-btn'>
                <button className='btn-rotate'><FiRotateCcw /></button>
                <label>Limpar</label>
              </div> */}
              <button className='btn-search' onClick={handleOtionsQuestion} >Filtrar</button>

            </div>
          </div>

        </div>
        <div className='container'>

          <p className='quatidade-questoes'>
            {getQuestions.length === 1 ? (
              <p>Foi encontrada {getQuestions.length} questão</p>
            ) : (
              <p>Foram encontradas {getQuestions.length} questões</p>
            )}
          </p>

          <ul>
            {getQuestions.map((question) => {
              //console.log("Question-referenceLink: ", question.referenceLink)
              const questionId = question.id
              //console.log("QuestionID: ", questionId)
              return (
                <li key={question.id}>
                  <div className='row'>
                    <p className='mark-number'></p>
                    <p>Q{question.q} | </p>
                    <p>{question.discipline} &gt; </p>
                    <p>{question.subject}</p>

                  </div>
                  <div className='row2'>
                    <p className='mark-row22'><p className='mark-row2' >Ano: </p>{question.year}</p>
                    <p className='mark-row22'><p className='mark-row2'>Banca: </p>{question.organizer}</p>
                    <p className='mark-row22'><p className='mark-row2'>Orgão: </p>{question.institution}</p>
                    {/* <p>Prova: Nome</p> */}
                  </div >
                  <hr />
                  <p className='box-question'>{question.enunciation}</p>

                  <ul className='box-alternativas'>
                    {Object.keys(question.options).sort().map((item) => {

                      //console.log("QUESTION: ", question.options)
                      const optionKey2 = question.options[item].idOption
                      const option = question.options[item]
                      const optionKey = item
                      const isCut = cutOptions[optionKey2];

                      return (
                        <li className='line-alternativa' key={optionKey2}>
                          <button
                            className='btn-tesoura'
                            onClick={() => handleCutOption(optionKey2)}
                          >
                            <img src={tesouraImg} alt='tesoura' />
                          </button>
                          <div className='box-option-text'>
                            <button
                              className='btn-alternative'
                              onClick={() => handleUncutOpption(optionKey2, question)}
                            >
                              {optionKey}
                            </button>
                            <p className={`text-alternative ${isCut ? 'cut' : ''}`}>
                              {option.text}
                            </p>
                          </div>

                        </li>
                      )
                    })}
                    <button onClick={() => handleResponse(questionId)}
                      className='btn-response'
                      style={{ opacity: visibleButtonResponse ? 1 : 0.5 }}
                      disabled={!visibleButtonResponse}
                    >
                      Responder
                    </button>
                    <div className='box-btn-adm'>
                      {user.status.adm === true ? (
                        <Link to={`/cadastrar-questao/${questionId}`} className='btn-response' >
                          Editar
                        </Link>
                      ) : (
                        <></>
                      )}
                      {user.status.adm === true ? (
                        <button onClick={() => handleDeletQuestions(questionId)} className='btn-response' >
                          Apagar
                        </button>
                      ) : (
                        <></>
                      )}
                    </div>


                    {/* {console.log("SelectedOption: ", selectedOption)} */}
                    {viewResponse && selectedOption === question.id ? (<p>Alternativa correta {trueFalse}</p>) : (<></>)}
                    <div className='box-button-question'>
                      <div className='line-color'></div>
                      <div className='box-options-question'>
                        <button className='btn-options-question' onClick={viewComment} disabled={disableComment === false}>Comentário</button>
                        <button className='btn-options-question' onClick={viewVideoLearn} disabled={disableLearnVideo === false} >Aula</button>
                        <button className='btn-options-question' disabled={true}>Estatistica</button>
                        <button className='btn-options-question' disabled={true}>Respotar Erro</button>
                      </div>
                    </div>
                    {/* {console.log("SelectedOption: ", selectedOption)} */}
                    {/* {console.log("Question.id: ", question.id)} */}
                    {viewCommentQuestion === true && question.id === selectedOption ? (

                      <div className='comment'>
                        <button style={{ position: 'absolute', top: 100, background: 'transparent', border: 0 }}>Fechar</button>
                        <p style={{ fontWeight: 600, top: 8, right: 10 }} >Comentário</p>
                        <p style={{ marginTop: 10 }} >{question.comments}</p>
                        <p style={{ fontWeight: 600, marginTop: 8 }} >Gabarito {trueFalse}</p>
                      </div>
                    ) : (
                      <></>
                    )}
                    {viewVideoLearnQuestion === true && selectedOption === question.id && question.referenceLink ? (
                      <div className='comment'>
                        <p style={{ fontWeight: 600, marginTop: 8 }} >Aula esplicativa</p>
                        <a style={{ marginTop: 10 }} href={question.referenceLink} target='_blank' >Aula</a>
                        {/* <p style={{ fontWeight: 600, marginTop: 8 }} >Gabarito</p> */}
                      </div>
                    ) : (
                      <></>
                    )}
                  </ul>
                </li>
              )
            })}
          </ul>

        </div>
      </Content >
    </>
  )
}